<form ngNativeValidate #signUpForm="ngForm" class="container-fluid" (submit)="signUp(); signUpForm.reset();">
  <div class="panel panel-danger">
    <div class="panel-heading"><h2>Sign Up for our Digital Marketing Dashboard</h2></div>
    <div class="panel-body">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="email" class="col-form-label">Email<span class="text-danger" title="* = Required Field">*</span></label>
          <input class="form-control required" type="email" id="email" required>
        </div>
        <div class="form-group col-md-6">
          <label for="password" class="col-form-label">Password<span class="text-danger" title="* = Required Field">*</span></label>
          <input class="form-control required" type="password" id="password" required>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="name" class="col-form-label">Name<span class="text-danger" title="* = Required Field">*</span></label>
          <input class="form-control required" type="text" id="name" required>
        </div>
        <div class="form-group col-md-6">
          <label for="details" class="col-form-label">Optional: What can we do for you?</label>
          <br />
          <textarea id="details" name="details" class="default form-control" rows="5" placeholder="(1) Business Name, (2) Requested Domain Name, (3) Any Other Details or Questions"></textarea>
        </div>
      </div>
    </div>
    <div class="panel-footer">
      <input type="submit" class="btn btn-danger" value="Sign Up" />
    </div>
    <div class="row text-center">
      <br />
      <a href="/portal" title="Digital Marketing Dashboard">Already Signed up?<br />Click here to go to Login.</a><br /><!--//jeb todo broken-->
      <br />
    </div>
  </div>
</form>
